module.exports = __webpack_public_path__ + "img/domestic-2006-civilization.cc2ecb9a.jpg";